import React, { useEffect } from 'react';
import { useAppDispatch } from 'ducks/hooks';
import { setNotification } from 'ducks/project-parameters/slices';
import { NotificationsProps } from 'ducks/types/prop-types';

import cn from 'templates/components/Components.module.scss';

export const Notifications = ({ message }: NotificationsProps) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    setTimeout(() => dispatch(setNotification(false)), 2000);
  }, [dispatch]);
  return (
    <div className={cn.clipboard}>
      <p>{message || 'Copied to clipboard'}</p>
    </div>
  );
};
